import React from 'react';
import { FancyShareDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { EpisodeRelayDto } from '@diritto/common/relay/dtos/episode-relay.dtos';
import { ReplyRelayDto } from '@diritto/common/relay/dtos/episode-reply-relay.dto';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { RollingRelayDto } from '@diritto/common/relay/dtos/rolling-relay.dtos';
import { SectionRelayDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import { SectionDefault } from 'app-components/home/sections/SectionDefault';
import { SectionText } from 'app-components/home/sections/SectionText';
import { HomeSectionViewMode } from 'constants/homeSectionViewMode';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';

type SectionProps = {
  section: SectionRelayDto;
  contents: Record<number, ContentRelayDto>;
  episodes: Record<number, EpisodeRelayDto>;
  profileLites: Record<number, ProfileLiteRelayDto>;
  replies: Record<number, ReplyRelayDto>;
  fancyShares: Record<number, FancyShareDto>;
  rollings: Record<number, RollingRelayDto>;
};

export const Section = ({
  section,
  contents,
  episodes,
  profileLites,
  replies,
  fancyShares,
  rollings,
  trackerExtraInfo,
}: SectionProps & TrackerExtraInfoProps) => {
  const { viewMode } = useHomeSettingState();

  if (viewMode === HomeSectionViewMode.Text) {
    return (
      <SectionText
        section={section}
        contents={contents}
        episodes={episodes}
        profileLites={profileLites}
        replies={replies}
        fancyShares={fancyShares}
        rollings={rollings}
        trackerExtraInfo={trackerExtraInfo}
      />
    );
  }

  return (
    <SectionDefault
      section={section}
      contents={contents}
      episodes={episodes}
      profileLites={profileLites}
      replies={replies}
      fancyShares={fancyShares}
      rollings={rollings}
      trackerExtraInfo={trackerExtraInfo}
    />
  );
};

export default Section;
